require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-meet-stefanie-from-psychology-to-software-development.json") })
        }
      }, "path---blog-meet-stefanie-from-psychology-to-software-development");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-meet-stefanie-from-psychology-to-software-development!./.cache/json/blog-meet-stefanie-from-psychology-to-software-development.json
// module id = 968
// module chunks = 231608221292675